module.exports = __webpack_public_path__ + "img/letter-from-hospital.4b669314.png";